<template>
    <div class="record-documents loading-content-container">
        <div v-if="isLoading" class="loading-overlay d-flex justify-content-center pt-5">
            <csp-loading-indicator/>
        </div>
        <b-row v-if="!isLoading">
            <b-col cols="8">
                <b-row v-if="canLoadDocuments" class="mb-4">
                    <csp-desktop-info-card :cols="12" icon="inticon-autoclaim_document_accident"
                        :link-icon="null" :router-link="{name: 'vehicleEditRoute'}"
                        title="Dokumente erzeugen">
                        <b-row>
                            <b-col cols="3">
                                <csp-record-detail-documents-modal
                                    :can-sign-documents="canSignDocuments"
                                    :record-id="recordId"
                                    @close-after-signature="updateFiles"/>
                            </b-col>
                            <b-col cols="3">
                                <csp-record-detail-document-print
                                    :can-print-documents="canPrintDocuments"
                                    :document-list="documentsPrintable"
                                    :documents-loaded="recordDocumentsLoaded"
                                    modal-type="Dokumente drucken"
                                    @document-generated="updateFiles"
                                    @modal-opened="loadDocuments"/>
                            </b-col>
                            <b-col cols="3">
                                <csp-record-detail-document-print
                                    :can-print-documents="canSendEmails"
                                    :document-list="documentsEmail"
                                    :documents-loaded="recordDocumentsLoaded && recordFirmSpecificDocumentsLoaded"
                                    :firm-specific-document-list="recordFirmSpecificDocuments"
                                    modal-type="E-Mail versenden"
                                    @document-generated="updateFiles"
                                    @modal-opened="loadDocumentsAndFirmSpecificDocuments"/>
                            </b-col>
                            <b-col cols="3">
                                <csp-record-detail-document-print
                                    :can-print-documents="canGenerateSpreadsheets"
                                    :document-list="documentsSpreadsheets"
                                    :documents-loaded="recordDocumentsLoaded"
                                    modal-type="Excel erzeugen"
                                    @document-generated="updateFiles"
                                    @modal-opened="loadDocuments"/>
                            </b-col>
                        </b-row>
                    </csp-desktop-info-card>
                </b-row>
                <b-row>
                    <csp-desktop-info-card :cols="12" icon="inticon-autoclaim_document_accident"
                        :link-icon="null" :router-link="{name: 'vehicleEditRoute'}"
                        title="vorhandene Dokumente">
                        <b-row>
                            <b-col cols="12">
                                <csp-record-detail-document-upload
                                    :record-id="recordId"
                                    @upload-success="updateFiles"/>
                                <br><br><br>
                                <div :class="'files-table' + recordFilesLoading > 0 ? 'loading-content-container' : ''">
                                    <div v-if="recordFilesLoading > 0"
                                        class="loading-overlay d-flex justify-content-center">
                                        <csp-loading-indicator/>
                                    </div>

                                    <b-alert v-if="recordFilesLoading === 0 && recordFilesForTable.length === 0"
                                        show variant="info">
                                        Keine Dokumente vorhanden
                                    </b-alert>

                                    <b-modal
                                        v-model="isOrderModalOpen"
                                        hide-footer
                                        size="lg"
                                        :title="'Filter / Sortierung für Datum'">
                                        <b-row align-v="center" class="table-legacy-modal">
                                            <b-col cols="6">
                                                Sortierung
                                            </b-col>
                                            <b-col cols="6">
                                                <csp-form-select-searchable :options="orderValues"
                                                    :value="selectedOrderDirection"
                                                    @change="orderDocumentsByDateSet($event)"/>
                                            </b-col>
                                        </b-row>

                                        <b-button class="mt-3 modal-button right" m variant="primary"
                                            @click="isOrderModalOpen = false">
                                            Sortierung anwenden
                                        </b-button>
                                    </b-modal>

                                    <b-table v-if="recordFilesLoading === 0 && recordFilesForTable.length > 0"
                                        :fields="visiblefileTableFields"
                                        :items="categorisedOrPlainFilesForTable"
                                        :responsive="true"
                                        :sort-by="selectedOrderValue"
                                        :sort-desc="selectedOrderDirection === 'desc'"
                                        striped
                                        @row-clicked="onFileTableRowClicked">
                                        <template v-slot:head(dateSet)="data">
                                            <div style="column-gap: 10px">
                                                <span>{{ data.label }}</span>
                                                <span class="filter-button ml-auto" @click="isOrderModalOpen = true">
                                                    <i class="inticon-filter"/>
                                                </span>
                                            </div>
                                        </template>

                                        <template v-slot:table-colgroup="scope">
                                            <col
                                                v-for="field in scope.fields"
                                                :key="field.key"
                                                :style="{ width: field.width ?? 'auto' }">
                                        </template>
                                        <template v-slot:cell(amount)="data">
                                            <span v-if="data.value > 1">
                                                <a href="#" @click.prevent="toggleCategory(data.item.fileCategoryId)">
                                                    {{ data.value }}
                                                </a>
                                            </span>
                                            <span v-else>
                                                {{ data.value }}
                                            </span>
                                        </template>
                                        <template v-slot:cell(dateSet)="data">
                                            {{ formatDateTime(data.value) }}
                                        </template>
                                        <template v-slot:cell(hideForGroup)="data">
                                            <!-- eslint-disable vue/max-len -->
                                            <csp-hide-for-group
                                                :can-toggle-fleet-manager-visibility="data.item.canToggleFleetManagerVisibility"
                                                :default-value="data.value"
                                                :mandatory-hide-for-group="data.item.mandatoryHideForGroup || []"
                                                :options="hideForGroupOptions"
                                                :record-id="recordId"
                                                :toggle-visibility-url="toggleVisibilityUrl(data.item)"
                                                @fleet-manager-visibility-toggled="toggleFleetManagerVisibility(data.item.fileId)"
                                                @reload="loadFiles"/>
                                            <!-- eslint-enable vue/max-len -->
                                        </template>
                                        <template v-slot:cell(actions)="data">
                                            <div class="table-actions">
                                                <a v-if="data.item.canUseKlippaDataApplicationModal"
                                                    href="#"
                                                    title="Dokument auslesen"
                                                    @click.prevent="openKlippaModal(data.item.fileId)">
                                                    <i class="inticon-autoclaim_weiterleiten"/>
                                                </a>
                                                <a v-if="data.item.canPreview"
                                                    :href="getPreviewFileUrl(data.item.fileId)"
                                                    target="_blank" title="Dokument in neuem Tab öffnen">
                                                    <i class="inticon-autoclaim_detail"/>
                                                </a>
                                                <a v-if="data.item.canEdit" href="#" title="Bearbeiten"
                                                    @click.prevent="editFileId = parseInt(data.item.fileId)">
                                                    <i class="inticon-autoclaim_bearbeiten"/>
                                                </a>
                                                <a v-if="data.item.canSplitFile" href="#" title="PDF aufteilen"
                                                    @click.prevent="splitFileId = parseInt(data.item.fileId)">
                                                    <i class="inticon-autoclaim_hinzufugen"/>
                                                </a>
                                                <a :href="getDownloadFileUrl(data.item.fileId)"
                                                    title="Datei herunterladen">
                                                    <i class="inticon-autoclaim_einzeldownload"/>
                                                </a>
                                                <a :href="getDownloadCategoryFilesUrl(data.item.fileCategoryId)"
                                                    title="Alle Dateien herunterladen">
                                                    <i class="inticon-autoclaim_mehrfachdownload"/>
                                                </a>
                                                <a v-if="data.item.canDelete" href="#" title="Löschen"
                                                    @click.prevent="deleteFile(data.item.fileId)">
                                                    <i class="inticon-autoclaim_loschen"/>
                                                </a>
                                            </div>
                                        </template>
                                    </b-table>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row v-if="!isLoading && !recordFilesLoading" class="mt-3">
                            <b-col>
                                <b-button @click="toggleAllCategories">
                                    {{ toggleAllCategoriesButtonLabel }}
                                </b-button>
                            </b-col>
                        </b-row>
                    </csp-desktop-info-card>
                </b-row>
            </b-col>
            <csp-desktop-info-card :cols="4" icon="inticon-autoclaim_document_accident" title="Dokumentenvorschau">
                <div class="loading-content-container">
                    <div v-if="galleryIsLoading" class="loading-overlay d-flex justify-content-center">
                        <csp-loading-indicator/>
                    </div>
                    <div v-if="!galleryIsLoading">
                        <div v-if="galleryFiles.length > 0 && galleryActiveIndex != null"
                            class="preview collapse-body mb-5" style="height: 450px;">
                            <div v-show="galleryActiveTitle" class="galleryActiveTitle text-center mb-4">
                                {{ galleryActiveTitle }}
                                <span class="mt-1">
                                    <br>&nbsp;
                                    <span v-show="currentGalleryFile && currentGalleryFile.pageCount != null">
                                        ({{ currentGalleryFile.pageCount }}
                                        {{ currentGalleryFile.pageCount === 1 ? 'Seite' : 'Seiten' }})
                                    </span>
                                </span>
                            </div>
                            <csp-file-gallery :active-index="galleryActiveIndex"
                                :disable-file-open="!canPreviewDocuments"
                                :files="galleryFiles"
                                :height="400"
                                :width="400 / 1.414"
                                @change="onGalleryChange"/>
                        </div>

                        <b-alert v-if="galleryFiles.length == 0" show variant="info">
                            Keine Dokumente vorhanden
                        </b-alert>
                    </div>
                </div>
            </csp-desktop-info-card>
        </b-row>
        <csp-record-data-application-form-modal
            ref="klippaModal"
            :file-id="selectedKlippaFileId"
            :form-context="klippaDataApplicationFormContext"
            :record-id="recordId"
            @created="updateFiles"
            @reset="selectedKlippaFileId = null"/>
        <csp-record-detail-file-edit
            v-if="editFileId"
            :file-id="editFileId"
            :record-id="recordId"
            @reset="editFileId = null"
            @updated="updateFiles"/>
        <csp-record-document-split-modal
            v-if="splitFileId"
            :file-id="splitFileId"
            :record-id="recordId"
            @close="onSplitModalClose"/>
    </div>
</template>


<script>
    import Container from '@services/Container';
    import FormContext from '@desktop/components/FormContext';
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';
    import {formatDate, formatDateTime} from '@js/functions/date';
    import DocumentPrintModal from '@desktop/components/record/document/DocumentPrintModal';
    import DocumentUploadModal from '@desktop/components/record/document/DocumentUploadModal';
    import FileEditModal from '@desktop/components/record/document/FileEditModal.vue';
    import SelectSearchable from '@components/form/SelectSearchable.vue';
    import DataApplicationFormModal from '@desktop/components/record/klippa/DataApplicationFormModal';

    const container = Container.getInstance();
    const recordRepositoryShared = container.getRecordRepository();
    const recordRepository = container.getDesktopRecordRepository();
    const flashMessenger = container.getFlashMessenger();

    export default {
        name: 'RecordDocuments',
        components: {
            'csp-record-detail-document-print': DocumentPrintModal,
            'csp-record-detail-document-upload': DocumentUploadModal,
            'csp-record-detail-file-edit': FileEditModal,
            'csp-form-select-searchable': SelectSearchable,
            'csp-record-data-application-form-modal': DataApplicationFormModal,
        },
        mixins: [FormDataMixin],
        data() {
            const recordId = parseInt(this.$route.params.recordId);
            return {
                recordId,
                isLoading: true,
                galleryActiveIndex: null,
                galleryFiles: [],
                currentGalleryFile: null,
                galleryIsLoading: true,
                orderValues: [
                    {value: null, text: 'keine (gruppiert)'},
                    {value: 'asc', text: 'aufsteigend'},
                    {value: 'desc', text: 'absteigend'},
                ],
                selectedOrderValue: null,
                selectedOrderDirection: null,
                isOrderModalOpen: false,
                fileTableFields: [
                    {
                        key: 'fileCategoryGroupName',
                        label: 'Zuordnung',
                        tdClass: 'carousel-click',
                        width: '50px',
                        visible: true,
                    },
                    {
                        key: 'fileCategoryName',
                        label: 'Kategorie',
                        tdClass: 'carousel-click',
                        width: '180px',
                        visible: true,
                    },
                    {
                        key: 'amount',
                        label: '#',
                        width: '36px',
                        visible: true,
                    },
                    {
                        key: 'fileName',
                        label: 'Dateiname',
                        class: 'd-none d-lg-table-cell',
                        tdClass: 'carousel-click',
                        visible: true,
                    },
                    {
                        key: 'dateSet',
                        label: 'Datum',
                        tdClass: 'carousel-click',
                        width: '130px',
                        visible: true,
                    },
                    {
                        key: 'createdByName',
                        label: 'von',
                        tdClass: 'carousel-click',
                        width: '120px',
                        visible: true,
                    },
                    {
                        key: 'hideForGroup',
                        label: 'Sichtbarkeit',
                        visible: true,
                        width: '210px',
                    },
                    {
                        key: 'actions',
                        label: '',
                        width: '190px',
                        visible: true,
                    },
                ],
                editFileId: null,
                splitFileId: null,
                selectedKlippaFileId: null,
                recordFiles: [],
                recordFilesLoading: 0,
                hideForGroupOptions: null,
                recordFileCategoriesExpanded: [],
                recordDocuments: [],
                recordDocumentsLoaded: false,
                recordFirmSpecificDocuments: [],
                recordFirmSpecificDocumentsLoaded: false,
                klippaDataApplicationFormContext: new FormContext({
                    name: 'dataApplicationForm',
                    objectId: this.recordId,
                    isAlwaysInEditMode: true,
                }),
            }
        },
        computed: {
            visiblefileTableFields() {
                return this.fileTableFields.filter(field => field.visible)
            },
            galleryActiveTitle() {
                if (!this.currentGalleryFile) return ''
                return this.currentGalleryFile.category + ' - ' + this.currentGalleryFile.name
            },
            documentsPrintable() {
                const documentsPrintable = [];

                this.recordDocuments.forEach((data) => {
                    const attributes = data.attributes;
                    const type = attributes.type;

                    if (type !== 'pdf') {
                        return;
                    }

                    documentsPrintable.push({
                        'documentId': data.id,
                        'key': data.id,
                        ...data.attributes,
                    });
                });

                return documentsPrintable;
            },
            documentsEmail() {
                const documentsEmail = [];

                this.recordDocuments.forEach((data) => {
                    const attributes = data.attributes;
                    const type = attributes.type;

                    if (type !== 'mail') {
                        return;
                    }

                    documentsEmail.push({
                        'documentId': data.id,
                        'key': data.id,
                        ...data.attributes,
                    });
                });

                return documentsEmail;
            },
            documentsSpreadsheets() {
                const documentsSpreadsheets = [];

                this.recordDocuments.forEach((data) => {
                    const attributes = data.attributes;
                    const type = attributes.type;

                    if (type !== 'spreadsheet') {
                        return;
                    }

                    documentsSpreadsheets.push({
                        'documentId': data.id,
                        'key': data.id,
                        ...data.attributes,
                    });
                });

                return documentsSpreadsheets;
            },
            recordFilesForTable() {
                const filesForTable = [];

                const counts = this.recordFiles.reduce((acc, item) => {
                    const key = item.attributes.fileCategoryId;
                    acc[key] = (acc[key] || 0) + 1;
                    return acc;
                }, {});

                this.recordFiles.forEach((data) => {
                    const categoryId = data.attributes.fileCategoryId;

                    const categoryShouldBeExpanded = this.recordFileCategoriesExpanded.includes(categoryId);
                    const fileCategoryAlreadyAdded = filesForTable.some(item => item.fileCategoryId === categoryId);
                    if (!categoryShouldBeExpanded && fileCategoryAlreadyAdded) {
                        return; // skip if category already exists and is not explicitly expanded
                    }

                    let amount = '';
                    if (!fileCategoryAlreadyAdded) {
                        // only set amount for the first file in the category
                        amount = counts[categoryId];
                    } else {
                        // for subsequent files we also remove category and categoryGroup name
                        data.attributes.fileCategoryGroupName = '';
                        data.attributes.fileCategoryName = '';
                    }

                    filesForTable.push({
                        fileId: data.id,
                        amount: amount,
                        ...data.attributes,
                        ...data.meta,
                    });
                });
                return filesForTable;
            },
            recordFilesForTableSorted() {
                const filesForTable = [];

                this.recordFiles.forEach((data) => {
                    const amount = 0;

                    filesForTable.push({
                        fileId: data.id,
                        amount: amount,
                        ...data.attributes,
                        ...data.meta,
                    });
                });
                return filesForTable;
            },
            categorisedOrPlainFilesForTable() {
                return this.selectedOrderValue !== null ? this.recordFilesForTableSorted : this.recordFilesForTable;
            },
            toggleAllCategoriesButtonLabel() {
                return this.recordFileCategoriesExpanded.length
                    ? 'Alle Kategorien einklappen' : 'Alle Kategorien ausklappen';
            },
        },
        watch: {
            selectedOrderValue(newValue) {
                if (newValue !== null) {
                    this.fileTableFields.find((field) => { return field.key === 'amount'}).visible = false;
                } else {
                    this.fileTableFields.find((field) => { return field.key === 'amount'}).visible = true;
                }
            },
        },
        created() {
            this.loadDocumentPermissions();
            this.updateFiles();
            this.loadHideForGroupOptions();
        },
        methods: {
            openKlippaModal(fileId) {
                this.selectedKlippaFileId = parseInt(fileId);
                this.$nextTick(() => {
                    this.$refs.klippaModal.openModal();
                });
            },
            orderDocumentsByDateSet(event) {
                if (event.value !== null) {
                    this.selectedOrderValue = 'dateSet';
                    this.selectedOrderDirection = event.value;
                } else {
                    this.selectedOrderValue = null;
                    this.selectedOrderDirection = null;
                }
                // Close modal directly, as sorting is immediately applied anyhow.
                this.isOrderModalOpen = false;
            },
            deleteFile(fileId) {
                if (!confirm('Möchten Sie diese Datei wirklich löschen?')) {
                    return;
                }
                this.recordFilesLoading++;
                recordRepository.deleteRecordFile(this.recordId, fileId).then(() => {
                    this.loadFiles();
                    this.loadGalleryFiles();
                    flashMessenger.addSuccess('Die Datei wurde gelöscht.');
                }).finally(() => {
                    this.recordFilesLoading--;
                });
            },
            formatDateTime,
            formatDate,
            getDownloadCategoryFilesUrl(fileCategoryId) {
                return recordRepositoryShared.buildFileZipDownloadUrl(this.recordId, fileCategoryId);
            },
            getDownloadFileUrl(fileId) {
                return recordRepositoryShared.buildFileDownloadUrlDownload(this.recordId, fileId);
            },
            getPreviewFileUrl(fileId) {
                return recordRepositoryShared.buildFileDownloadUrl(this.recordId, fileId);
            },
            resetFileEdit() {
                this.editFileId = null;
            },
            onSplitModalClose() {
                this.splitFileId = null;
                this.updateFiles();
            },
            updateFiles() {
                this.loadGalleryFiles();
                this.loadFiles();
            },
            toggleCategory(fileCategoryId) {
                if (this.recordFileCategoriesExpanded.includes(fileCategoryId)) {
                    this.recordFileCategoriesExpanded = this.recordFileCategoriesExpanded.filter(function(item) {
                        return item !== fileCategoryId
                    })
                } else {
                    this.recordFileCategoriesExpanded.push(fileCategoryId);
                }
            },
            toggleAllCategories() {
                if (this.recordFileCategoriesExpanded.length) {
                    // one or more categories are expanded, collapse all
                    this.recordFileCategoriesExpanded = [];
                    return;
                }

                // expand all categories
                let fileCategories = new Set();
                this.recordFiles.forEach(recordFile => {
                    fileCategories.add(recordFile.attributes.fileCategoryId);
                });
                this.recordFileCategoriesExpanded = Array.from(fileCategories);
            },
            toggleVisibilityUrl(tableItem) {
                if (tableItem.canToggleVisibility !== true) {
                    return null;
                }
                return recordRepository.buildFileToggleVisibilityUrl(this.recordId, tableItem.fileId);
            },
            onFileTableRowClicked(item, index, event) {
                if (!event.target.closest('td.carousel-click')) {
                    return;
                }
                this.showFileInGallery(item.fileId);
            },
            onGalleryChange(galleryActiveIndex) {
                this.currentGalleryFile = this.galleryFiles[galleryActiveIndex]
                this.galleryActiveIndex = galleryActiveIndex
            },
            showFileInGallery(fileId) {
                fileId = parseInt(fileId);
                const index = this.galleryFiles.findIndex(file => file.fileId === fileId);
                if (index !== -1) {
                    this.onGalleryChange(index);
                }
            },
            toggleFleetManagerVisibility(fileId) {
                recordRepository.toggleRecordFileFleetManagerVisibility(this.recordId, fileId).then(
                    () => {
                        this.loadFiles();
                    }
                );
            },
            loadDocumentPermissions() {
                recordRepository.loadDocumentsOverview(this.recordId).then(response => {
                    this.canLoadDocuments = response.data.meta.permissions.canLoadDocuments;
                    this.canPreviewDocuments = response.data.meta.permissions.canPreviewDocuments;
                    this.canSignDocuments = response.data.meta.permissions.canSignDocuments;
                    this.canPrintDocuments = response.data.meta.permissions.canPrintDocuments;
                    this.canSendEmails = response.data.meta.permissions.canSendEmails;
                    this.canGenerateSpreadsheets = response.data.meta.permissions.canGenerateSpreadsheets;
                    this.isLoading = false;
                })
            },
            loadGalleryFiles() {
                this.galleryIsLoading = true;
                return recordRepositoryShared.getThumbnailData(this.recordId, 'carousel')
                    .then((data) => {
                        const items = data.data.map(fileThumbnail => {
                            const thumbnailAttributes = fileThumbnail.attributes;
                            const fileId = thumbnailAttributes.fileId;
                            let thumbnailUrl = recordRepositoryShared.buildThumbnailDownloadUrl(
                                this.recordId, fileId, 'carousel'
                            );
                            if (thumbnailAttributes.overrideThumbnailUrl) {
                                // If the file has an override URL, use it instead of the default download URL
                                thumbnailUrl = thumbnailAttributes.overrideThumbnailUrl;
                            }
                            return {
                                fileId,
                                thumbnailId: thumbnailAttributes.thumbnailId,
                                name: thumbnailAttributes.fileName,
                                category: thumbnailAttributes.fileCategoryName,
                                pageCount: thumbnailAttributes.pageCount ?? null,
                                thumbnailUrl,
                                url: recordRepositoryShared.buildFileDownloadUrl(this.recordId, fileId),
                            };
                        });

                        this.galleryFiles = items;

                        if (this.galleryFiles.length > 0) {
                            this.onGalleryChange(Math.min(this.galleryActiveIndex ?? 0, this.galleryFiles.length - 1));
                        } else {
                            this.galleryActiveIndex = null;
                            this.currentGalleryFile = null;
                        }
                    })
                    .finally(() => { this.galleryIsLoading = false; });
            },
            loadFiles() {
                this.recordFilesLoading++;
                return recordRepositoryShared.getFileData(this.recordId).then(
                    (data) => {
                        this.recordFiles = data.data.attributes.files.data;
                        this.recordFilesLoading--;
                    }
                );
            },
            loadDocuments() {
                if (this.recordDocumentsLoaded) {
                    // If documents are already loaded, no need to reload
                    return;
                }
                return recordRepository.loadDocuments(this.recordId).then(
                    (data) => {
                        this.recordDocuments = data.data;
                    }).finally(
                    () => {
                        this.recordDocumentsLoaded = true;
                    });
            },
            loadFirmSpecificDocuments() {
                if (this.recordFirmSpecificDocumentsLoaded) {
                    // If documents are already loaded, no need to reload
                    return;
                }
                return recordRepository.loadFirmSpecificDocuments(this.recordId).then(
                    (data) => {
                        this.recordFirmSpecificDocuments = data.data;
                    }).finally(
                    () => {
                        this.recordFirmSpecificDocumentsLoaded = true;
                    });
            },
            loadDocumentsAndFirmSpecificDocuments() {
                this.loadDocuments();
                this.loadFirmSpecificDocuments();
            },
            loadHideForGroupOptions() {
                this.recordFilesLoading++;
                recordRepositoryShared.hideForGroupOptions(this.recordId).then(
                    (options) => {
                        this.hideForGroupOptions = options;
                    }
                ).finally(() => {
                    this.recordFilesLoading--;
                });
            },
        },
    }
</script>
